<template>
	<div>
		<h2 class="text-center">Statistiques de l'enquête de satisfaction</h2>
		<br/>
		<div v-if="appreciationQuestions">
			<ul>
				<li v-for="(item, index) in appreciationQuestions">
					<span v-html="alphabet[index] + ' : ' + item"></span>
				</li>
			</ul>
			<chart :options="appreciationChart"></chart>
		</div>
		<div v-if="yesNoQuestions">
			<hr>
			<ul>
				<li v-for="(item, index) in yesNoQuestions">
					<span v-html="alphabet[appreciationQuestions.length + index] + ' : ' + item"></span>
				</li>
			</ul>
			<chart :options="yesNoChart"></chart>
		</div>
	</div>
</template>

<script>
import Chart from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'

	export default {
		components: {
			Chart
		},
		computed: {
			userData: function() {
				return this.$store.state.statistics.satisfaction.userData;
			},
			groupData: function() {
				return this.$store.state.statistics.satisfaction.groupData;
			},
			appreciationQuestions: function() {
				return this.$store.state.statistics.satisfaction.questions['APPRECIATION'];
			},
			yesNoQuestions: function() {
				return this.$store.state.statistics.satisfaction.questions['YES_NO'];
			},
			appreciationChart: function()	{
				this.initAppreciationChart();
				this.groupData['APPRECIATION'].forEach(function(value, index, array)	{
					let stringIndex = this.appreciationIndexes[index];
					this.appreciationChartConfig.legend.data.push(stringIndex);
					this.addAppreciationSerie(stringIndex, value);
				}, this);
				return this.appreciationChartConfig;

			},
			yesNoChart: function()	{
				this.initYesNoChart();
				this.groupData['YES_NO'].forEach(function(value, index, array)	{
					let stringIndex = this.yesNoIndexes[index];
					this.yesNoChartConfig.legend.data.push(stringIndex);
					this.addYesNoSerie(stringIndex, value);
				}, this);
				return this.yesNoChartConfig;			
			}
		},
		methods: {
			initAppreciationChart()	{
				for (let i = (this.appreciationQuestions.length - 1); i >= 0 ; i--)	{
					this.appreciationChartConfig.yAxis.data.push(this.alphabet[i]);
				}
			},
			initYesNoChart()	{
				for (let i = (this.appreciationQuestions.length + this.yesNoQuestions.length - 1); i >= this.appreciationQuestions.length; i--)	{
					this.yesNoChartConfig.yAxis.data.push(this.alphabet[i]);
				}
			},
			addAppreciationSerie(name, data)	{
				this.appreciationChartConfig.series.push({
		            name: name,
		            type: 'bar',
		            stack: 'stack',
		            label: {
		                normal: {
		                    show: false,
		                    position: 'insideRight'
		                }
		            },
		            data: data
		        });
			},
			addYesNoSerie(name, data)	{
				this.yesNoChartConfig.series.push({
		            name: name,
		            type: 'bar',
		            stack: 'stack',
		            label: {
		                normal: {
		                    show: false,
		                    position: 'insideRight'
		                }
		            },
		            data: data
		        });
			}
		},
		data: function()	{
			return {
				alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
				appreciationIndexes: ['-2', '-1', '+1', '+2'],
				yesNoIndexes: ['Oui', 'Non'],
				appreciationChartConfig: {
				    tooltip : {
				        trigger: 'axis',
				        axisPointer : {
				        	type : 'shadow'
				        }
				    },
				    legend: {
				        data: []
				    },
				    grid: {
				        containLabel: true
				    },
				    xAxis:  {
				        type: 'value'
				    },
				    yAxis: {
				        type: 'category',
				        data: []
				    },
				    series: []
				},
				yesNoChartConfig: {
				    tooltip : {
				        trigger: 'axis',
				        axisPointer : {
				        	type : 'shadow'
				        }
				    },
				    legend: {
				        data: []
				    },
				    grid: {
				        containLabel: true
				    },
				    xAxis:  {
				        type: 'value'
				    },
				    yAxis: {
				        type: 'category',
				        data: []
				    },
				    series: []
				}
			};
		},
		props: {
			user: {type: Boolean, default: false},
			group: {type: Boolean, default: false},
			id: {type: Number, default: 0}
		},
		beforeCreate()	{
			this.$store.commit('SATISFACTION_STATISTICS_UPDATED', {
		        userData: {
		            'APPRECIATION': [],
		            'YES_NO': []
		        },
		        groupData: {
		            'APPRECIATION': [],
		            'YES_NO': []
		        },
		        questions:  {
		            'APPRECIATION': [],
		            'YES_NO': []
		        }
		    });
		},
		created()	{
			if (!this.user && this.group)	{
				this.$store.dispatch('getSessionSatisfactionStatistics', {
					parentTargetInstanceId: this.id ? this.id : this.$route.params.sessionId,
					callbacks: { success: (data) => {
						this.$store.commit("SATISFACTION_STATISTICS_UPDATED", data);
					}
				}});
			}
			else	{
				this.$store.dispatch('getInstanceSatisfactionStatistics', {
					instanceId: this.id ? this.id : this.$route.params.instanceId,
					mode: this.user && this.group ? 2 : 1,
					callbacks: { success: (data) => {
						this.$store.commit("SATISFACTION_STATISTICS_UPDATED", data);
					}
				}});	
			}

		}
	};
</script>


<style>

</style>
